"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StandardDisplayCard = _interopRequireDefault(require("./StandardDisplayCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _StandardDisplayCard.default;
exports.default = _default;